import React, { useLayoutEffect, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DollarVector from "../imgs/DollarVector.svg";
import NumberFormat from "react-number-format";
import { useNavigate } from "react-router-dom";
import Chart from "react-google-charts";
import { format } from "date-fns";
import "react-tippy/dist/tippy.css";
import { Tooltip } from "react-tippy";
import { jsPDF } from "jspdf";
import "jspdf/dist/polyfills.es.js";
import html2canvas from "html2canvas";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import PopupPresupuesto from "../components/PopupPresupuesto";

export default function Results() {
  const [t, i18n] = useTranslation("global");
  console.log(i18n.language);

  const { state } = useLocation();
  const navigate = useNavigate();

  //Constantes TSS
  const TSS_MAX_SALARIO_PP = 464460.0;
  const TSS_PORCENT_PP = 0.0287;
  const COMPANY_TSS_PORCENT_PP = 0.071;
  const TSS_MAX_SALARIO_SS = 232230.0;
  const TSS_PORCENT_SS = 0.0304;
  const COMPANY_TSS_PORCENT_SS = 0.0709;
  const TSS_TARIFA_DEPENDIENTES_ADICIONALES = 1919.78;
  const TSS_LABORAL_RISK_LIMIT = 92892.0;

  //Constantes ISR
  const L_INFERIORES = [0, 416220.01, 624329.01, 867123.01];
  const L_SUPERIORES = [416220, 624329, 867123, 999999999];
  const TASA_EXCEDENTES = [0, 0.15, 0.2, 0.25];

  //Constantes de Cálculo
  const MESES_ANO = 12;

  // const format_type = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",

  //   // These options are needed to round to whole numbers if that's what you want.
  //   minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //   //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  // });

  const formatter = (number) => {
    if (isNaN(number)) return "Invalid number";

    // Convert number to string for processing
    const numberAsString = number.toString();

    // Split the number into integer and decimal parts
    let [integerPart, decimalPart] = numberAsString.split(".");

    // Use regular expression to insert commas as thousand separators in the integer part
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Reassemble the number
    const formattedNumber = decimalPart
      ? `${integerPart}.${decimalPart}`
      : integerPart;

    return `$${formattedNumber}`;
  };

  //Variables de Resultados
  const [resultadosTSS, setResultadosTSS] = useState({});
  const [resultadosISR, setResultadosISR] = useState({});
  const [riesgoLaboralSelect, setRiesgoLaboralSelect] = useState(1);
  const [salarioNeto, setSalarioNeto] = useState(0);
  const [printHide, setPrintHide] = useState(true);
  const [shadowEffect1, setShadowEffect1] = useState("shadow-3xl");
  const [shadowEffect2, setShadowEffect2] = useState("shadow-4xl");
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [graphData, setGraphData] = useState([]);
  const [legendFontSize, setLegendFontSize] = useState(18);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [showBreakdown, setShowBreakdown] = useState(false);

  const detectWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectWindowResize);

    if (windowWidth < 700) {
      setLegendFontSize(16);
    } else {
      setLegendFontSize(18);
    }

    return () => {
      window.removeEventListener("resize", detectWindowResize);
    };
  }, [windowWidth]);

  const options = {
    pieHole: 0.4,
    fontSize: legendFontSize,
    is3D: false,
    legend: { alignment: "center", position: "bottom" },
    // chartArea:{right:50}
  };

  const riesgoLaboralOptions = [
    {
      label: t("results.laboral-risk-opt-1"),
      value: 1,
      percent: 0.011,
    },
    {
      label: t("results.laboral-risk-opt-2"),
      value: 2,
      percent: 0.0115,
    },
    {
      label: t("results.laboral-risk-opt-3"),
      value: 3,
      percent: 0.012,
    },
    {
      label: t("results.laboral-risk-opt-4"),
      value: 4,
      percent: 0.013,
    },
  ];

  const handleChange = (selectedOption) => {
    setRiesgoLaboralSelect(selectedOption.value);
  };

  const generatePDF = () => {
    const input = document.getElementById("content");
    html2canvas(input, {
      logging: true,
      letterRendering: 1,
      useCORS: true,
    }).then((canvas) => {
      const imgWidth = 408;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const imgData = canvas.toDataURL("img/png");
      const pdf = new jsPDF("l", "mm", "a3");
      pdf.addImage(imgData, "png", 5, 0, imgWidth, imgHeight);
      pdf.addFont("montserrat");
      pdf.text(t("results.print-title"), 184, 260);
      pdf.addFont("montserrat");
      pdf.setTextColor(0, 32, 255);
      pdf.text(t("results.print-link"), 184, 270);
      pdf.save("resultados.pdf");
    });
  };

  useLayoutEffect(() => {
    if (window.innerWidth < 700) {
      setLegendFontSize(16);
    } else {
      setLegendFontSize(18);
    }

    //Lógica de Cálculo

    //CALCULO TSS

    let ingresosCotizablesTSS =
      Number(state.sueldo) + Number(state.ingresosCotizables);
    let resultadosTSSLocal = {
      ingresosCotizables: ingresosCotizablesTSS,
      planPensiones:
        truncateDecimals(ingresosCotizablesTSS * TSS_PORCENT_PP * 100) / 100,
      planSalud:
        truncateDecimals(ingresosCotizablesTSS * TSS_PORCENT_SS * 100) / 100,
      dependientes: {
        cantidad: Number(state.dependientes),
        monto:
          truncateDecimals(
            Number(state.dependientes) *
              TSS_TARIFA_DEPENDIENTES_ADICIONALES *
              100,
          ) / 100,
      },
      total: 0,
    };

    if (ingresosCotizablesTSS > TSS_MAX_SALARIO_PP) {
      resultadosTSSLocal.planPensiones =
        truncateDecimals(TSS_MAX_SALARIO_PP * TSS_PORCENT_PP * 100) / 100;
    }
    if (ingresosCotizablesTSS > TSS_MAX_SALARIO_SS) {
      resultadosTSSLocal.planSalud =
        truncateDecimals(TSS_MAX_SALARIO_SS * TSS_PORCENT_SS * 100) / 100;
    }

    resultadosTSSLocal.total =
      resultadosTSSLocal.planPensiones +
      resultadosTSSLocal.planSalud +
      resultadosTSSLocal.dependientes.monto;
    resultadosTSSLocal.porcentaje =
      (resultadosTSSLocal.total * 1.0) /
      (resultadosTSSLocal.ingresosCotizables * 1.0);
    setResultadosTSS(resultadosTSSLocal);

    //CALCULO ISR
    let ingresosCotizablesISR =
      Number(state.sueldo) +
      Number(state.ingresosNoCotizables) +
      Number(state.ingresosCotizables);
    let resultadosISRLocal = {
      ingresosCotizables: ingresosCotizablesISR,
      salarioNetoImponible: ingresosCotizablesISR - resultadosTSSLocal.total,
    };

    // Función para calcular ISR sin redondeos intermedios
    const calculateISR = (salarioNetoImponible) => {
      const salarioNetoImponibleAnual = salarioNetoImponible * MESES_ANO;
      let isrTotalAnual = 0;
      let montosLimites = [0]; // Banda 0 siempre es 0

      // Cálculo banda por banda SIN redondeos intermedios
      for (let i = 1; i < 4; i++) {
        let montoISRBanda = 0;

        if (salarioNetoImponibleAnual <= L_INFERIORES[i]) {
          // No aplica esta banda
          montoISRBanda = 0;
        } else if (salarioNetoImponibleAnual <= L_SUPERIORES[i]) {
          // El salario está dentro de esta banda
          const baseImponible = salarioNetoImponibleAnual - L_INFERIORES[i];
          montoISRBanda = baseImponible * TASA_EXCEDENTES[i];
        } else {
          // El salario supera esta banda completa
          const baseImponible = L_SUPERIORES[i] - L_INFERIORES[i];
          montoISRBanda = baseImponible * TASA_EXCEDENTES[i];
        }

        // Convertir a mensual SIN redondear
        const montoMensual = montoISRBanda / MESES_ANO;
        montosLimites.push(montoMensual);
        isrTotalAnual += montoISRBanda;
      }

      return {
        isrMensual: isrTotalAnual / MESES_ANO,
        montosLimites: montosLimites,
      };
    };

    // Usar la nueva función
    const isrResult = calculateISR(resultadosISRLocal.salarioNetoImponible);

    resultadosISRLocal.montosLimites = isrResult.montosLimites;
    resultadosISRLocal.total = isrResult.isrMensual;
    resultadosISRLocal.porcentaje =
      resultadosISRLocal.salarioNetoImponible > 0
        ? resultadosISRLocal.total / resultadosISRLocal.salarioNetoImponible
        : 0;
    setResultadosISR(resultadosISRLocal);

    //SALARIO NETO
    setSalarioNeto(
      Number(state.sueldo) +
        Number(state.ingresosCotizables) +
        Number(state.ingresosNoCotizables) -
        resultadosTSSLocal.total -
        resultadosISRLocal.total,
    );

    setGraphData([
      ["Montos Totales", "En Pesos Dominicanos ($DOP)"],
      [
        t("results.net-salary"),
        Number(state.sueldo) +
          Number(state.ingresosCotizables) +
          Number(state.ingresosNoCotizables) -
          resultadosTSSLocal.total -
          resultadosISRLocal.total,
      ],
      [t("results.salary-composition-tss-total"), resultadosTSSLocal.total],
      [t("results.salary-composition-isr-total"), resultadosISRLocal.total],
    ]);
  }, []);

  let truncateDecimals = function (number) {
    return Math[number < 0 ? "ceil" : "floor"](number);
  };

  useEffect(() => {
    // if(!printHide) window.print() ; setPrintHide(true)
    if (!printHide) {
      setPaddingPrint(20);
      setShadowEffect1("");
      setShadowEffect2("");
      generatePDF();
      setPrintHide(true);
    } else {
      setPaddingPrint(0);
      setShadowEffect1("shadow-3xl");
      setShadowEffect2("shadow-4xl");
    }
  }, [printHide]);

  const riesgoLaboralAmount =
    resultadosTSS.ingresosCotizables < TSS_LABORAL_RISK_LIMIT
      ? resultadosTSS.ingresosCotizables *
        riesgoLaboralOptions[riesgoLaboralSelect - 1].percent
      : TSS_LABORAL_RISK_LIMIT *
        riesgoLaboralOptions[riesgoLaboralSelect - 1].percent;

  const planPensionEmpleador =
    Math.min(resultadosTSS.ingresosCotizables, TSS_MAX_SALARIO_PP) *
    COMPANY_TSS_PORCENT_PP;
  const planSaludEmpleador =
    Math.min(resultadosTSS.ingresosCotizables, TSS_MAX_SALARIO_SS) *
    COMPANY_TSS_PORCENT_SS;
  // const totalAportesEmpleador =
  //   planPensionEmpleador + planSaludEmpleador + riesgoLaboralAmount;

  const planPensionEmpleado =
    Math.min(resultadosTSS.ingresosCotizables, TSS_MAX_SALARIO_PP) *
    TSS_PORCENT_PP;
  const planSaludEmpleado =
    Math.min(resultadosTSS.ingresosCotizables, TSS_MAX_SALARIO_SS) *
    TSS_PORCENT_SS;
  // const dependientesAdicionales = resultadosTSS.dependientes?.monto || 0;
  // const totalAportesEmpleado =
  //   planPensionEmpleado + planSaludEmpleado + dependientesAdicionales;

  // const totalAportesTSS = totalAportesEmpleador + totalAportesEmpleado;

  const distribucionAportesARS = [
    {
      label: t("results.employer-health"),
      percent: COMPANY_TSS_PORCENT_SS,
      amount: planSaludEmpleador,
    },
    {
      label: t("results.employee-health"),
      percent: TSS_PORCENT_SS,
      amount: planSaludEmpleado,
    },
    {
      label: t("results.health-contributions-total"),
      percent: TSS_PORCENT_SS + COMPANY_TSS_PORCENT_SS,
      amount: planSaludEmpleado + planSaludEmpleador,
    },
  ];

  const detalleAportesARS = [
    { label: t("results.ars-breakdown-subtitle"), percent: null },
    {
      label: t("results.health-care"),
      percent: 0.0953,
      amount: resultadosTSS.ingresosCotizables * 0.0953,
    },
    {
      label: t("results.childcare"),
      percent: 0.001,
      amount: resultadosTSS.ingresosCotizables * 0.001,
    },
    {
      label: t("results.subsidies"),
      percent: 0.0043,
      amount: resultadosTSS.ingresosCotizables * 0.0043,
    },
    {
      label: t("results.superintendence-operation-sisalril"),
      percent: 0.0007,
      amount: resultadosTSS.ingresosCotizables * 0.0007,
    },
  ];

  const distribucionAportesAFP = [
    {
      label: t("results.employer"),
      percent: COMPANY_TSS_PORCENT_PP,
      amount: planPensionEmpleador,
    },
    {
      label: t("results.affiliate"),
      percent: TSS_PORCENT_PP,
      amount: planPensionEmpleado,
    },
    {
      label: t("results.total-part"),
      percent: COMPANY_TSS_PORCENT_PP + TSS_PORCENT_PP,
      amount: planPensionEmpleado + planPensionEmpleador,
    },
    { label: t("results.afp-breakdown-subtitle"), percent: null },
    {
      label: t("results.personal-account"),
      percent: 0.084,
      amount: resultadosTSS.ingresosCotizables * 0.084,
    },
    {
      label: t("results.life-insurance"),
      percent: 0.0095,
      amount: resultadosTSS.ingresosCotizables * 0.0095,
    },
    {
      label: t("results.social-fund"),
      percent: 0.004,
      amount: resultadosTSS.ingresosCotizables * 0.004,
    },
    {
      label: t("results.tss-operation"),
      percent: 0.001,
      amount: resultadosTSS.ingresosCotizables * 0.001,
    },
    {
      label: t("results.superintendence-operation-pensions"),
      percent: 0.0007,
      amount: resultadosTSS.ingresosCotizables * 0.0007,
    },
    {
      label: t("results.superintendence-operation-dida"),
      percent: 0.0005,
      amount: resultadosTSS.ingresosCotizables * 0.0005,
    },
  ];
  // const distribucionAportes = [
  //   // {
  //   //   label: t("results.affiliate"),
  //   //   percent: 0.0287,
  //   //   amount: planPensionEmpleado,
  //   // },
  //   // {
  //   //   label: t("results.employer"),
  //   //   percent: 0.071,
  //   //   amount: planPensionEmpleador,
  //   // },
  //   // {
  //   //   label: t("results.total-part"),
  //   //   percent: 0.0997,
  //   //   amount: planPensionEmpleado + planPensionEmpleador,
  //   // },
  //   {
  //     label: t("results.personal-account"),
  //     percent: 0.084,
  //     amount: totalAportesEmpleado,
  //   },
  //   {
  //     label: t("results.life-insurance"),
  //     percent: 0.0095,
  //     amount: resultadosTSS.ingresosCotizables * 0.0095,
  //   },
  //   {
  //     label: t("results.social-fund"),
  //     percent: 0.004,
  //     amount: resultadosTSS.ingresosCotizables * 0.004,
  //   },
  //   {
  //     label: t("results.tss-operation"),
  //     percent: 0.001,
  //     amount: resultadosTSS.ingresosCotizables * 0.001,
  //   },
  //   {
  //     label: t("results.superintendence-operation"),
  //     percent: 0.0007,
  //     amount: resultadosTSS.ingresosCotizables * 0.0007,
  //   },
  //   {
  //     label: t("results.dida-operation"),
  //     percent: 0.0005,
  //     amount: resultadosTSS.ingresosCotizables * 0.0005,
  //   },
  // ];

  return (
    <div
      id="content"
      className="w-[100%] block print:landscape print:block lg:landscape lg:flex lg:justify-center lg:scale-75 lg:-mt-96 [print-color-adjust: exact !important] [-ms-print-color-adjust: exact] [-moz-print-color-adjust: exact;] [-webkit-print-color-adjust: exact !important]"
    >
      {!printHide && (
        <div className="flex w-full absolute font-montserrat justify-end pr-6">
          <p>{format(new Date(), t("results.date-format"))}</p>
        </div>
      )}
      {printHide && (
        <div className="flex w-full absolute justify-start pl-6 pt-5 lg:pt-0 font-monserrat">
          <button
            onClick={(e) => {
              e.preventDefault();

              navigate("/calculadora-de-salarios/datos", { state: state });
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10 16l-6-6 6-6" />
              <path d="M20 21v-7a4 4 0 0 0-4-4H5" />
            </svg>
          </button>
        </div>
      )}
      <div className={salarioNeto > 0 ? "block" : " hidden"}>
        <div className="flex justify-center font-dmSans">
          {/* Title */}
          <h1 className="font-bold text-2xl 2xl:text-3xl 5xl:text-4xl 4xl:leading-[40px] leading-[30px] pt-16 lg:pt-0 ">
            {t("results.page-title")}
          </h1>
        </div>
        {/* Title Underline */}
        {printHide && (
          <img
            src={require("../imgs/Title-Line.png")}
            alt=""
            className="hidden lg:block float-right lg:w-[55%] xl:w-[50%] 4xl:pr-[35rem] 4xl:mr-[5rem] pr-[20rem] mr-[5rem] print:hidden"
          />
        )}

        {/* Results Layout */}
        <div className="block print:pt-10 pb-10 mb-10">
          {/* Buttons */}
          {printHide && (
            <div className="block lg:flex justify-center self-center pl-2 flex-grow w-full pt-5 font-montserrat print:hidden">
              <button
                onClick={(e) => {
                  e.preventDefault();

                  navigate("/calculadora-de-salarios/datos", { state: state });
                }}
                className="inline-flex p-2 border-2 border-[#4856DF] rounded-full mr-2 hover:bg-[#F5F5F5]"
              >
                <svg
                  className="mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4856DF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                  <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                </svg>{" "}
                {t("results.edit-button")}
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();

                  navigate("/calculadora-de-salarios/datos", {
                    state: {
                      sueldo: 0,
                      dependientes: 0,
                      ingresosCotizables: 0,
                      ingresosNoCotizables: 0,
                    },
                  });
                }}
                className="inline-flex p-2 border-2 border-[#4856DF] rounded-full mr-2 hover:bg-[#F5F5F5]"
              >
                <svg
                  className="mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4856DF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38" />
                </svg>
                {t("results.new-button")}
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setPrintHide(false);
                }}
                className="hidden lg:inline-flex p-2 border-2 border-[#4856DF] rounded-full mr-2 hover:bg-[#F5F5F5]"
              >
                <svg
                  className="mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#4856DF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 6 2 18 2 18 9"></polyline>
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                  <rect x="6" y="14" width="12" height="8"></rect>
                </svg>{" "}
                {t("results.print-button")}
              </button>
            </div>
          )}
          {/* TSS and ISR RESULTS */}
          <div className="lg:flex print:flex font-montserrat pt-4">
            {/* TSS */}
            <div className="block pl-10">
              <h1 className="flex font-semibold text-left xl:text-lg pb-4">
                {t("results.tss-result-title")}{" "}
                {printHide && (
                  <Tooltip
                    title={t("results.tss-guide-tooltip")}
                    position="top"
                    animation="perspective"
                    className="w-[50px] pl-1"
                    html={
                      <div className="block text-sm">
                        <h5>{`${t(
                          "results.tss-tooltip-minimum-wage",
                        )}: ${formatter(
                          (TSS_MAX_SALARIO_SS / 10).toFixed(2),
                        )}`}</h5>
                        <h5>
                          {`${t(
                            "results.tss-tooltip-max-wage-pension-plan",
                          )}: ${formatter(TSS_MAX_SALARIO_PP.toFixed(2))}`}
                        </h5>
                        <h5>{`${t(
                          "results.tss-tooltip-max-wage-health-plan",
                        )}: ${formatter(TSS_MAX_SALARIO_SS.toFixed(2))}`}</h5>
                      </div>
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#DA7E12"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12.01" y2="8"></line>
                    </svg>
                  </Tooltip>
                )}
              </h1>
              {/* Ingresos Cotizables Section */}
              <div className="flex pb-8">
                <div
                  className={`bg-[#FFCC40] p-4 rounded-lg mr-4 ${shadowEffect1}`}
                >
                  <img src={DollarVector} alt="" className="self-center" />
                </div>
                {/* Display Ingresos Cotizables TSS */}
                <div className="text-left self-center">
                  <NumberFormat
                    value={resultadosTSS.ingresosCotizables}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="font-bold text-xl "
                  />

                  <p className="font-medium text-[#8A8A8A] text-xs sm:text-sm pt-[-2rem]">
                    {t("results.tss-result-subtitle")}
                  </p>
                </div>
              </div>
              {/* Cuotas Section */}
              <div className={`block lg:pr-0 pr-10 pt-${paddingPrint}`}>
                <h2 className="font-bold text-left pb-4">
                  {t("results.tss-table-title")}
                </h2>
                {/* Cuotas Box */}
                <div className="flex flex-col bg-[#F5F5F5] rounded-md">
                  <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="overflow-hidden">
                        <table className="min-w-full border-collapse ">
                          <thead className="text-center font-bold uppercase">
                            <tr className="">
                              <th
                                scope="col"
                                className="text-sm text-[#6F6F84] px-4 py-2 "
                              >
                                {t("results.tss-table-id")}
                              </th>
                              <th
                                scope="col"
                                className="text-sm text-[#6F6F84] px-4 py-2 "
                              >
                                {t("results.tss-table-desc")}
                              </th>
                              <th
                                scope="col"
                                className="text-sm text-[#6F6F84] px-4 py-2 "
                              >
                                {t("results.tss-table-quantity")}
                              </th>
                              <th
                                scope="col"
                                className="text-sm text-[#6F6F84] px-4 py-2"
                              >
                                {t("results.tss-table-rate")}
                              </th>
                              <th
                                scope="col"
                                className="text-sm text-[#6F6F84] px-2 py-2"
                              >
                                {t("results.tss-table-amount")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="">
                              <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                1
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap text-left">
                                {t("results.tss-table-row-1-desc")} &#40;
                                {TSS_PORCENT_PP * 100}%&#41;
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap">
                                -
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap">
                                -
                              </td>
                              <td className="text-sm px-2 py-1 pr-4 whitespace-nowrap text-right">
                                <NumberFormat
                                  value={resultadosTSS.planPensiones}
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                  className={`text-sm`}
                                />
                              </td>
                            </tr>
                            <tr className="">
                              <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                2
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap text-left">
                                {t("results.tss-table-row-2-desc")} &#40;
                                {TSS_PORCENT_SS * 100}%&#41;
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap">
                                -
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap">
                                -
                              </td>
                              <td className="text-sm px-2 pr-4 py-1 whitespace-nowrap text-right">
                                <NumberFormat
                                  value={resultadosTSS.planSalud}
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                  className={`text-sm`}
                                />
                              </td>
                            </tr>
                            <tr className="">
                              <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                3
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap text-left">
                                {t("results.tss-table-row-3-desc")}
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap text-center">
                                {resultadosTSS?.dependientes?.cantidad}
                              </td>
                              <td className="text-sm px-4 py-1 whitespace-nowrap text-right">
                                <NumberFormat
                                  value={TSS_TARIFA_DEPENDIENTES_ADICIONALES}
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                />
                              </td>
                              <td className="text-sm px-2 pr-4 py-1 whitespace-nowrap text-right">
                                <NumberFormat
                                  value={resultadosTSS?.dependientes?.monto}
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div className="block">
                          <hr className="mt-2 border-solid border-black border-y-[0.5px] ml-16 mr-4" />
                          <div className="flex font-bold text-lg pt-4 pb-1 ml-16">
                            <p>Total</p>
                            <p className="ml-1 text-[#6F6F84]">&#40;TSS&#41;</p>
                            <NumberFormat
                              value={
                                truncateDecimals(
                                  Math.fround(resultadosTSS?.total * 100),
                                ) / 100
                              }
                              displayType={"text"}
                              decimalScale={2}
                              fixedDecimalScale={false}
                              thousandSeparator={true}
                              prefix="$"
                              className="grow text-right pr-4 text-[#DA7E12]"
                            />

                            {/* <span className="grow text-right pr-4 text-[#DA7E12]">
                              ${" "}
                              {truncateDecimals(
                                Math.fround(resultadosTSS?.total * 100)
                              ) / 100}
                            </span> */}
                          </div>
                          <div className="flex font-bold text-sm pb-1 ml-16">
                            <p>%</p>
                            <p className="inline-flex ml-1 text-[#6F6F84] ">
                              &#40;TSS&#41;
                              <div className="justify-start self-start pl-1 print:hidden">
                                {printHide && (
                                  <Tooltip
                                    title={t("results.tss-tooltip")}
                                    position="top"
                                    animation="perspective"
                                    className="w-[50px]"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="#DA7E12"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="12"
                                        y1="16"
                                        x2="12"
                                        y2="12"
                                      ></line>
                                      <line
                                        x1="12"
                                        y1="8"
                                        x2="12.01"
                                        y2="8"
                                      ></line>
                                    </svg>
                                  </Tooltip>
                                )}
                              </div>
                            </p>
                            <NumberFormat
                              value={resultadosTSS?.porcentaje * 100}
                              displayType={"text"}
                              decimalScale={1}
                              fixedDecimalScale={true}
                              thousandSeparator={true}
                              suffix="%"
                              className="grow text-right pr-6 text-[#DA7E12]"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ISR */}
            <div className="block">
              <div
                className={`block lg:pl-14 print:pl-14 pl-10 pt-${paddingPrint}`}
              >
                <h1 className="pt-4 lg:pt-0 font-semibold text-left xl:text-lg pb-4">
                  {t("results.isr-result-title")}
                </h1>
                {/* Ingresos Section */}
                <div className="lg:flex print:flex pb-8 lg:min-w-[35rem]">
                  <div className="flex lg:pr-8 print:pr-8">
                    <div
                      className={`bg-[#783EFD] p-4 rounded-lg mr-4 ${shadowEffect2}`}
                    >
                      <img src={DollarVector} alt="" className="self-center" />
                    </div>

                    {/* Display Ingresos Cotizables TSS */}
                    <div className="text-left self-center">
                      <NumberFormat
                        value={resultadosISR.ingresosCotizables}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                        className="font-bold text-xl "
                      />

                      <p className="font-medium text-[#8A8A8A] text-xs sm:text-sm pt-[-2rem]">
                        {t("results.isr-quotable-income-subtitle")}
                      </p>
                    </div>
                  </div>

                  <div className="flex pt-4 print:pt-0 lg:pt-0">
                    <div
                      className={`bg-[#4856DF] p-4 rounded-lg mr-4 ${shadowEffect2}`}
                    >
                      <img src={DollarVector} alt="" className="self-center" />
                    </div>

                    {/* Display Ingresos Cotizables TSS */}
                    <div className="text-left self-center">
                      <NumberFormat
                        value={resultadosISR.salarioNetoImponible}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                        className="font-bold text-xl "
                      />

                      <p className="font-medium text-[#8A8A8A] text-xs sm:text-sm pt-[-2rem]">
                        {t("results.isr-net-salary-subtitle")}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Tabla ISR - DGII Section */}
                {resultadosISR.montosLimites && (
                  <div className="block lg:pr-0 pr-10">
                    <h2 className="font-bold text-left pb-4">
                      {t("results.isr-table-title")}
                    </h2>
                    {/* ISR Box */}
                    <div className="flex flex-col bg-[#F5F5F5] rounded-md">
                      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="overflow-hidden">
                            <table className="min-w-full border-collapse ">
                              <thead className="text-center font-bold uppercase">
                                <tr className="">
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] p-6 py-2 "
                                  >
                                    {t("results.isr-table-id")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-6 py-2 "
                                  >
                                    {t("results.isr-table-low-limit")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-6 py-2 "
                                  >
                                    {t("results.isr-table-up-limit")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-6 py-2"
                                  >
                                    {t("results.isr-table-rate")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-6 py-2"
                                  >
                                    {t("results.isr-table-amount")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="">
                                  <td className="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    1
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    0
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    34,685.00
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap">
                                    0%
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={resultadosISR?.montosLimites[0]}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                  </td>
                                </tr>
                                <tr className="">
                                  <td className="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    2
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    34,685.01
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    52,027.42
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap">
                                    15%
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={resultadosISR?.montosLimites[1]}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                    {/* <span className="text-sm">
                                      ${" "}
                                      {truncateDecimals(
                                        Math.fround(
                                          resultadosISR?.montosLimites[1] * 100
                                        )
                                      ) / 100}
                                    </span> */}
                                  </td>
                                </tr>
                                <tr className="">
                                  <td className="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    3
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    52,027.43
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    72,260.25
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap">
                                    20%
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={resultadosISR?.montosLimites[2]}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                  </td>
                                </tr>
                                <tr className="">
                                  <td className="px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    4
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    72,260.26
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    999,999,999.00
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap">
                                    25%
                                  </td>
                                  <td className="text-sm px-6 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={resultadosISR?.montosLimites[3]}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="block">
                              <hr className="mt-2 border-solid border-black border-y-[0.5px] ml-24 mr-6" />
                              <div className="flex font-bold text-lg pt-4 pb-1 ml-24">
                                <p>Total</p>
                                <p className="ml-1 text-[#6F6F84]">
                                  &#40;ISR&#41;
                                </p>
                                <NumberFormat
                                  value={resultadosISR?.total}
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                  className="grow text-right pr-6 text-[#783EFD]"
                                />
                              </div>
                              <div className="flex font-bold text-sm pb-1 ml-24">
                                <p>%</p>
                                <p className="inline-flex ml-1 text-[#6F6F84] ">
                                  &#40;ISR&#41;
                                  <div className="justify-start self-start pl-1 print:hidden">
                                    {printHide && (
                                      <Tooltip
                                        title={t("results.isr-tooltip")}
                                        position="top"
                                        animation="perspective"
                                        className="w-[50px]"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#793DDC"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                          ></circle>
                                          <line
                                            x1="12"
                                            y1="16"
                                            x2="12"
                                            y2="12"
                                          ></line>
                                          <line
                                            x1="12"
                                            y1="8"
                                            x2="12.01"
                                            y2="8"
                                          ></line>
                                        </svg>
                                      </Tooltip>
                                    )}
                                  </div>
                                </p>
                                <NumberFormat
                                  value={resultadosISR?.porcentaje * 100}
                                  displayType={"text"}
                                  decimalScale={1}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  suffix="%"
                                  className="grow text-right pr-6 text-[#783EFD]"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Total Results */}
          <div
            className={`lg:flex print:flex pt-10 pl-10 font-montserrat pb-10 lg:pr-0 print:pr-0 pr-10 text-left justify-center space-x-4  pt-${paddingPrint}`}
          >
            {/* Total Box */}
            <div className="block bg-[#046865] text-white rounded-lg lg:min-w-[30rem] print:min-w-[30rem] pb-[5px] lg:pb-0">
              <h1 className="font-bold text-left pl-4 pt-4 text-xl">Total</h1>
              <span className="font-semibold flex pl-4 pt-2">
                {t("results.total-income")} <p className="lg:pl-[30px]">=</p>
                <div className="lg:inline-flex print:inline-flex block pl-2 font-light">
                  <NumberFormat
                    value={resultadosISR.ingresosCotizables}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pr-2 lg:flex block"
                  />
                </div>{" "}
              </span>
              <span className="font-semibold flex pl-4 pt-2">
                {t("results.total-discounts")} ={" "}
                <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                  {t("results.total-discounts-formula")}
                </p>{" "}
              </span>
              <span className="font-semibold flex pl-4 pt-2">
                {t("results.total-discounts")} ={" "}
                <div className="lg:inline-flex print:inline-flex block pl-2 font-light">
                  <NumberFormat
                    value={resultadosTSS.total}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pr-2 lg:flex block"
                  />
                  +
                  <NumberFormat
                    value={resultadosISR.total}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pl-2 pr-2 lg:flex block"
                  />
                  ={" "}
                  <NumberFormat
                    value={resultadosISR.total + resultadosTSS.total}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pl-2 pr-2 lg:flex block"
                  />
                </div>{" "}
              </span>
              <span className="font-semibold flex pl-4 pt-2">
                {t("results.net-salary")} <p className="lg:pl-[46.5px]">=</p>
                <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                  {t("results.total-income")} - {t("results.total-discounts")}
                </p>{" "}
              </span>
              <span className="font-semibold flex pl-4 lg:pt-1 pt-2 pb-4">
                {t("results.net-salary")} <p className="lg:pl-[46.5px]">=</p>
                <div className="lg:inline-flex print:inline-flex block pl-2 font-light">
                  <NumberFormat
                    value={resultadosISR.ingresosCotizables}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pr-2 lg:flex block"
                  />
                  -
                  <NumberFormat
                    value={resultadosISR.total + resultadosTSS.total}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="pl-2 pr-2 lg:flex block"
                  />
                </div>{" "}
              </span>
            </div>
            <div className="lg:mt-0 mt-4 block bg-[#046865] text-white rounded-lg lg:min-w-[30rem] print:min-w-[30rem] pb-[5px] lg:pb-0">
              <h1 className="font-bold text-left pl-4 pt-4 text-xl">Total</h1>
              <div className="flex print:flex justify-center self-center lg:p-4 p-[0.7rem] bg-[#EBEBEB] text-xl rounded-lg max-w-min lg:max-w-none w-fit mt-10 mb-4 ml-4 lg:ml-[15.7%] print:ml-[15.7%]">
                <span className="lg:self-center lg:justify-center print:self-center print:justify-center font-bold text-black">
                  {t("results.net-salary")} =
                  <NumberFormat
                    value={salarioNeto}
                    displayType={"text"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    thousandSeparator={true}
                    prefix="$"
                    className="text-[#046865] non-italic pl-2"
                  />{" "}
                </span>
              </div>
            </div>
            {printHide && <PopupPresupuesto salarioNeto={salarioNeto} />}
          </div>

          {printHide && (
            <div className="flex justify-center pt-20">
              <div className="block">
                <div className="flex justify-center">
                  <div
                    className={`block max-w-xl lg:pr-0 pt-${paddingPrint} pb-10`}
                  >
                    <h2 className="text-xl font-semibold text-center pb-4 flex justify-center pl-16">
                      {t("results.company-tss-table-title")}{" "}
                      {printHide && (
                        <Tooltip
                          title={t("results.tss-guide-tooltip")}
                          position="top"
                          animation="perspective"
                          className="w-[50px] pl-1"
                          html={
                            <div className="block text-sm">
                              <h5>{`${t(
                                "results.tss-tooltip-max-wage-arl",
                              )}: ${formatter(
                                TSS_LABORAL_RISK_LIMIT.toFixed(2),
                              )}`}</h5>
                            </div>
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#DA7E12"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                          </svg>
                        </Tooltip>
                      )}
                    </h2>
                    {/* Cuotas Box */}
                    <div className="flex flex-col bg-[#F5F5F5] rounded-md">
                      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                          <div className="overflow-hidden">
                            <table className="min-w-full lg:w-[30rem] border-collapse ">
                              <thead className="text-center font-bold uppercase">
                                <tr className="">
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-4 py-2 "
                                  >
                                    {t("results.tss-table-id")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-4 py-2 "
                                  >
                                    {t("results.tss-table-desc")}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-4 py-2 "
                                  >
                                    {"           "}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-4 py-2"
                                  >
                                    {"           "}
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-sm text-[#6F6F84] px-2 py-2"
                                  >
                                    {t("results.tss-table-amount")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="">
                                  <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    1
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap text-left">
                                    {t("results.tss-table-row-1-desc")} &#40;
                                    {COMPANY_TSS_PORCENT_PP * 100}%&#41;
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-2 py-1 pr-4 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={
                                        resultadosTSS.ingresosCotizables <
                                        TSS_MAX_SALARIO_PP
                                          ? resultadosTSS.ingresosCotizables *
                                            COMPANY_TSS_PORCENT_PP
                                          : TSS_MAX_SALARIO_PP *
                                            COMPANY_TSS_PORCENT_PP
                                      }
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                  </td>
                                </tr>
                                <tr className="">
                                  <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    2
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap text-left">
                                    {t("results.tss-table-row-2-desc")} &#40;
                                    {(COMPANY_TSS_PORCENT_SS * 100).toFixed(2)}
                                    %&#41;
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-2 pr-4 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={
                                        resultadosTSS.ingresosCotizables <
                                        TSS_MAX_SALARIO_SS
                                          ? resultadosTSS.ingresosCotizables *
                                            COMPANY_TSS_PORCENT_SS
                                          : TSS_MAX_SALARIO_SS *
                                            COMPANY_TSS_PORCENT_SS
                                      }
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className={`text-sm`}
                                    />
                                  </td>
                                </tr>
                                <tr className="">
                                  <td className="px-2 py-1 whitespace-nowrap text-sm font-medium text-gray-900">
                                    3
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap text-left flex">
                                    {t("results.company-tss-table-row-3-desc")}{" "}
                                    &#40;
                                    {(
                                      riesgoLaboralOptions[
                                        riesgoLaboralSelect - 1
                                      ].percent * 100
                                    ).toFixed(2)}
                                    %&#41;
                                    <div className="justify-start self-start pl-1 print:hidden"></div>
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap text-center">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-4 py-1 whitespace-nowrap text-center">
                                    {" "}
                                  </td>
                                  <td className="text-sm px-2 pr-4 py-1 whitespace-nowrap text-right">
                                    <NumberFormat
                                      value={riesgoLaboralAmount}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="block">
                              <hr className="mt-2 border-solid border-black border-y-[0.5px] ml-16 mr-4" />
                              <div className="flex font-bold text-lg pt-4 pb-1 ml-16">
                                <p>Total</p>
                                <p className="ml-1 text-[#6F6F84]">
                                  &#40;TSS&#41;
                                </p>
                                <NumberFormat
                                  value={
                                    riesgoLaboralAmount +
                                    (resultadosTSS.ingresosCotizables <
                                    TSS_MAX_SALARIO_SS
                                      ? resultadosTSS.ingresosCotizables *
                                        COMPANY_TSS_PORCENT_SS
                                      : TSS_MAX_SALARIO_SS *
                                        COMPANY_TSS_PORCENT_SS) +
                                    (resultadosTSS.ingresosCotizables <
                                    TSS_MAX_SALARIO_PP
                                      ? resultadosTSS.ingresosCotizables *
                                        COMPANY_TSS_PORCENT_PP
                                      : TSS_MAX_SALARIO_PP *
                                        COMPANY_TSS_PORCENT_PP)
                                  }
                                  displayType={"text"}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  prefix="$"
                                  className="grow text-right pr-4 text-[#DA7E12]"
                                />
                              </div>
                              <div className="flex font-bold text-sm pb-1 ml-16">
                                <p>%</p>
                                <p className="inline-flex ml-1 text-[#6F6F84] ">
                                  &#40;TSS&#41;
                                  <div className="justify-start self-start pl-1 print:hidden">
                                    {printHide && (
                                      <Tooltip
                                        title={t("results.tss-tooltip")}
                                        position="top"
                                        animation="perspective"
                                        className="w-[50px]"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="#DA7E12"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                          ></circle>
                                          <line
                                            x1="12"
                                            y1="16"
                                            x2="12"
                                            y2="12"
                                          ></line>
                                          <line
                                            x1="12"
                                            y1="8"
                                            x2="12.01"
                                            y2="8"
                                          ></line>
                                        </svg>
                                      </Tooltip>
                                    )}
                                  </div>
                                </p>
                                <NumberFormat
                                  value={
                                    ((riesgoLaboralAmount +
                                      (resultadosTSS.ingresosCotizables <
                                      TSS_MAX_SALARIO_SS
                                        ? resultadosTSS.ingresosCotizables *
                                          COMPANY_TSS_PORCENT_SS
                                        : TSS_MAX_SALARIO_SS *
                                          COMPANY_TSS_PORCENT_SS) +
                                      (resultadosTSS.ingresosCotizables <
                                      TSS_MAX_SALARIO_PP
                                        ? resultadosTSS.ingresosCotizables *
                                          COMPANY_TSS_PORCENT_PP
                                        : TSS_MAX_SALARIO_PP *
                                          COMPANY_TSS_PORCENT_PP)) /
                                      resultadosTSS.ingresosCotizables) *
                                    100
                                  }
                                  displayType={"text"}
                                  decimalScale={1}
                                  fixedDecimalScale={true}
                                  thousandSeparator={true}
                                  suffix="%"
                                  className="grow text-right pr-6 text-[#DA7E12]"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Select
                      value={riesgoLaboralOptions[riesgoLaboralSelect - 1]}
                      options={riesgoLaboralOptions}
                      onChange={handleChange}
                      isSearchable={false}
                    />
                  </div>
                </div>

                <div className="lg:mt-0 mt-4  block bg-[#046865] text-white rounded-lg lg:min-w-[30rem] print:min-w-[30rem] pb-[5px]  p-2">
                  <h1 className="font-bold text-left pl-4 pt-4 text-xl">
                    {t("results.total-tss")}
                  </h1>

                  <span className="font-semibold flex pl-4 pt-2">
                    {t("results.total-tss")} ={" "}
                    <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                      {t("results.total-tss-formula")}
                    </p>{" "}
                  </span>
                  <span className="font-semibold flex pl-4 pt-2">
                    {t("results.employer-contribution")} ={" "}
                    <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                      {t("results.total-tss-employer-formula")}
                    </p>{" "}
                  </span>
                  <span className="font-semibold flex pl-4 pt-2">
                    {t("results.employer-contribution")} ={" "}
                    <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                      <NumberFormat
                        value={
                          resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_PP
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_PP
                            : TSS_MAX_SALARIO_PP * COMPANY_TSS_PORCENT_PP
                        }
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      +{" "}
                      <NumberFormat
                        value={
                          resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_SS
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_SS
                            : TSS_MAX_SALARIO_SS * COMPANY_TSS_PORCENT_SS
                        }
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      +{" "}
                      <NumberFormat
                        value={riesgoLaboralAmount}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      ={" "}
                      <NumberFormat
                        value={
                          riesgoLaboralAmount +
                          (resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_SS
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_SS
                            : TSS_MAX_SALARIO_SS * COMPANY_TSS_PORCENT_SS) +
                          (resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_PP
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_PP
                            : TSS_MAX_SALARIO_PP * COMPANY_TSS_PORCENT_PP)
                        }
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />
                    </p>{" "}
                  </span>
                  <span className="font-semibold flex pl-4 pt-2">
                    {t("results.employee-contribution")} ={" "}
                    <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                      {t("results.total-tss-employee-formula")}
                    </p>{" "}
                  </span>
                  <span className="font-semibold flex pl-4 pt-2">
                    {t("results.employee-contribution")} ={" "}
                    <p className="pl-2 font-light max-w-[161px] lg:max-w-full print:max-w-full">
                      <NumberFormat
                        value={resultadosTSS.planPensiones}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      +{" "}
                      <NumberFormat
                        value={resultadosTSS.planSalud}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      +{" "}
                      <NumberFormat
                        value={resultadosTSS?.dependientes?.monto}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                      ={" "}
                      <NumberFormat
                        value={resultadosTSS.total}
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                      />{" "}
                    </p>{" "}
                  </span>
                  <div className="lg:flex print:flex justify-center self-center lg:p-4 p-[0.7rem] bg-[#EBEBEB] text-xl rounded-lg w-fit mt-4 mb-4 lg:ml-[12.5%] print:ml-[15.7%]">
                    <span className="lg:self-center lg:justify-center print:self-center print:justify-center font-bold text-black">
                      {t("results.total-tss")} =
                      <NumberFormat
                        value={
                          riesgoLaboralAmount +
                          (resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_SS
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_SS
                            : TSS_MAX_SALARIO_SS * COMPANY_TSS_PORCENT_SS) +
                          (resultadosTSS.ingresosCotizables < TSS_MAX_SALARIO_PP
                            ? resultadosTSS.ingresosCotizables *
                              COMPANY_TSS_PORCENT_PP
                            : TSS_MAX_SALARIO_PP * COMPANY_TSS_PORCENT_PP) +
                          resultadosTSS.total
                        }
                        displayType={"text"}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandSeparator={true}
                        prefix="$"
                        className="text-[#046865] non-italic pl-2"
                      />{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* DESGLOCE APORTES desgloce aportes */}

          <div className="flex justify-center">
            <div className="flex flex-col items-center">
              <button
                onClick={() => setShowBreakdown(!showBreakdown)}
                className={`lg:mt-6 w-fit mt-4 flex justify-center bg-[#2b4785] hover:bg-[#253558] text-white ring-2 shadow-md hover:shadow-xl ring-gray-500 outline-2 rounded-lg p-4 print:hidden`}
              >
                {showBreakdown
                  ? t("results.hide-breakdown")
                  : t("results.show-breakdown")}
              </button>

              {showBreakdown && (
                <div className="lg:mt-6 block w-fit mt-4 bg-[#3b5998] text-white rounded-lg p-4">
                  <h2 className="font-bold text-left pl-4 pt-4 text-xl">
                    {t("results.contribution-distribution")}
                  </h2>

                  <div className="pl-4 pt-2">
                    <div className="flex">
                      <div className="block px-4">
                        <h3 className="font-bold pt-2">
                          {t("results.ars-contributions")}
                        </h3>
                        <table className="w-full">
                          <tbody>
                            {distribucionAportesARS.map((item, index) => (
                              <tr
                                key={index}
                                className={`${
                                  index === 2
                                    ? "pb-2 font-extrabold underline"
                                    : "font-semibold"
                                }`}
                              >
                                <td className="text-left pr-2">{item.label}</td>
                                <td className="text-center w-[60px]">
                                  {item.percent &&
                                    `(${(item.percent * 100).toFixed(2)}%)`}
                                </td>
                                <td className="text-right pl-2">
                                  {item.percent && (
                                    <NumberFormat
                                      value={item.amount}
                                      displayType={"text"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={true}
                                      prefix="$"
                                      className="text-right"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))}
                            {detalleAportesARS.map((item, index) => (
                              <React.Fragment key={index}>
                                {item.percent === null && (
                                  <tr>
                                    <td colSpan="3" className="py-1"></td>
                                  </tr>
                                )}
                                <tr
                                  className={`font-semibold ${
                                    item.percent === null
                                      ? "py-2 text-center"
                                      : ""
                                  }`}
                                >
                                  <td
                                    className={`text-left pr-2 ${
                                      item.percent === null
                                        ? "py-2 text-center"
                                        : ""
                                    }`}
                                  >
                                    {item.label}
                                  </td>
                                  <td className="text-center w-[60px]">
                                    {item.percent &&
                                      `(${(item.percent * 100).toFixed(2)}%)`}
                                  </td>
                                  <td className="text-right pl-2">
                                    {item.percent && (
                                      <NumberFormat
                                        value={item.amount}
                                        displayType={"text"}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        prefix="$"
                                        className="text-right"
                                      />
                                    )}
                                  </td>
                                </tr>
                                {item.percent === null && (
                                  <tr>
                                    <td colSpan="3" className="py-1"></td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="flex flex-col w-max">
                        <h3 className="font-bold pt-2">
                          {t("results.afp-contributions")}
                        </h3>
                        <table className="w-full">
                          <tbody>
                            {distribucionAportesAFP.map((item, index) => (
                              <React.Fragment key={index}>
                                {item.percent === null && (
                                  <tr>
                                    <td colSpan="3" className="py-1"></td>
                                  </tr>
                                )}
                                <tr
                                  className={`${
                                    index === 2
                                      ? "pb-2 font-extrabold underline"
                                      : "font-semibold"
                                  }`}
                                >
                                  <td
                                    className={`text-left pr-2 ${
                                      item.percent === null
                                        ? "py-2 text-center"
                                        : ""
                                    }`}
                                  >
                                    {item.label}
                                  </td>
                                  <td className="text-center w-[60px]">
                                    {item.percent &&
                                      `(${(item.percent * 100).toFixed(2)}%)`}
                                  </td>
                                  <td className="text-right pl-2">
                                    {item.percent && (
                                      <NumberFormat
                                        value={item.amount}
                                        displayType={"text"}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                        thousandSeparator={true}
                                        prefix="$"
                                        className="text-right"
                                      />
                                    )}
                                  </td>
                                </tr>
                                {item.percent === null && (
                                  <tr>
                                    <td colSpan="3" className="py-1"></td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {printHide && (
            <div className="lg:pt-20">
              <h1 className="font-montserrat text-xl font-semibold text-center">
                {t("results.salary-composition-title")}
              </h1>
              <Chart
                chartType="PieChart"
                width="100%"
                height="400px"
                data={graphData}
                options={options}
              />
            </div>
          )}

          {printHide && (
            <div className="block pt-20">
              <div className="text-xl font-semibold">
                {t("results.laboral-risk-title")}
              </div>

              <div className="mt-8 lg:flex justify-center text-black font-dmSans bg-[#F6FAFD] px-10 py-10 5xl:h-[1200px] min-h-[306px]  4xl:min-h-[460px]">
                {/* Left Side */}

                <div className="bg-white rounded-[8px] lg:w-96 lg:mr-5 p-8 border-2 pb-30">
                  <div className="flex">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                    </svg>
                    <p className="text-[22px] text-left ml-2">
                      {t("results.tss-company-article-18")}
                    </p>
                  </div>
                  <div className="block">
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-laboral-risk-tooltip")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-laboral-risk-tooltip-1")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-laboral-risk-tooltip-2")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-laboral-risk-tooltip-3")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-laboral-risk-tooltip-4")}
                    </p>
                  </div>
                </div>

                <div className="bg-white max-h-[28rem] rounded-[8px] lg:w-96 p-8 border-2 mt-5 lg:mt-0 pb-30">
                  <div className="flex">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M21.5 12H16c-.7 2-2 3-4 3s-3.3-1-4-3H2.5" />
                      <path d="M5.5 5.1L2 12v6c0 1.1.9 2 2 2h16a2 2 0 002-2v-6l-3.4-6.9A2 2 0 0016.8 4H7.2a2 2 0 00-1.8 1.1z" />
                    </svg>{" "}
                    <p className="text-[22px] text-left ml-2">
                      {t("results.tss-company-article-21")}
                    </p>
                  </div>
                  <div className="block">
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-article-21-desc-1")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-article-21-desc-2")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-article-21-desc-3")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-article-21-desc-4")}
                    </p>
                    <p className="text-left text-[14px] mt-5">
                      {t("results.tss-company-article-21-desc-5")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* {!printHide&&<div className="print:block bottom-0 absolute w-full w-[100%]">
         <p className="font-montserrat font-italic pt-16">Esta herramienta es parte de:</p>
        <a href="https://www.educacionlaboral.com.do" className="text-blue-500">www.educacionlaboral.com.do</a>
    </div>} */}
    </div>
  );
}
